import * as z from 'zod';

export const SystemSchema = z.enum([
  'space_heating',
  'space_cooling',
  'ventilation',
  'domestic_hot_water',
  'mechanical',
  'plug_loads',
  'appliances',
  'on_site_generation',
  'other',
]);
export type System = z.infer<typeof SystemSchema>;
